"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AddMediaIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 7.97A4 4 0 019.252 2.6H1.5A1.5 1.5 0 000 4.1v9.4A1.5 1.5 0 001.5 15H12a1.5 1.5 0 001.5-1.5V7.97zm-5.621.084a.574.574 0 01.996-.008l2.47 4.23a.574.574 0 01-.496.864H1.608a.574.574 0 01-.482-.886L2.995 9.37a.574.574 0 01.915-.063l1.446 1.666c.26.3.739.252.934-.095l1.589-2.825zM2.48 5.7a1.24 1.24 0 102.48 0 1.24 1.24 0 00-2.48 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13 7a3 3 0 100-6 3 3 0 000 6zm1.833-3a.333.333 0 01-.333.333h-1.167V5.5a.333.333 0 11-.666 0V4.333H11.5a.333.333 0 010-.666h1.167V2.5a.333.333 0 11.666 0v1.167H14.5c.184 0 .333.149.333.333z",
    clipRule: "evenodd"
  })))
});
AddMediaIcon.displayName = 'AddMediaIcon';
var _default = exports.default = AddMediaIcon;